module.exports = __webpack_public_path__ + "img/th.ca1ede7d.png";